<template>
  <div>
    <vs-alert :active.sync="errorOccurred" color="danger" title="Error While Loading Course">
      <span>We were unable to load Course with Id {{ activeCourseInfo.id }} successfully.</span>
    </vs-alert>
    <div v-if="!errorOccurred">

      <div class="vx-row">
        <div class="vx-col w-full mb-6">
          <div class="knowledge-base-jumbotron-content rounded-lg p-8 lg:p-12 vx-card"
               style="background-image: url(https://cdn.discordapp.com/attachments/746242308084858900/878036059005526016/sylvain-mauroux-jYCUBAIUsk8-unsplash.jpg); background-position: center">
            <div class="flex justify-between items-center">
              <div class="flex flex-wrap content-center pl-6 pr-6">
                <h1 class="mb-2 text-white w-full" style="font-size: 4rem">Flashcard Mode</h1>
                <p class="text-white w-full" style="font-size: 1.5rem" v-if="activeCourseInfo.selected">You are
                  currently
                  practicing {{ activeCourseInfo.name }}</p>
                <p class="text-white w-full" style="font-size: 1.5rem" v-if="!activeCourseInfo.selected">No Course
                  Selected, Begin By Selecting Your Active Course</p>
                <!--- <vs-progress
                  :percent="dashboard_course_percent" style="max-width: 600px"
                  class="block mt-6 shadow-md self-center w-2/3" color="success"></vs-progress> --->
              </div>
              <img class="rounded ml-10" :src="activeCourseInfo.thumbnail" v-if="activeCourseInfo.thumbnail"
                   width="150px"
                   height="150px">
            </div>
          </div>
        </div>
      </div>

      <div class="vx-row" v-if="courseData && selectorData">
        <div class="vx-col w-full">
          <div v-for="domain in selectorData">
            <div class="flex justify-between mb-1 p-2">
              <h2 class="font-light">{{ domain.name }}</h2>
              <h2 class="font-bold">{{ domain.sets.length }} Sets</h2>
            </div>
            <div class="mb-6 p-6 rounded-lg" style="background-color: rgba(0,0,0,0.15) ">
              <div class="grid grid-cols-3 gap-5">
                <div v-for="(set, index) in domain.sets" class="flex items-center justify-center">
                  <div class="w-full" @mouseleave="lottieStop(`setStarter${set.id}_${index}`)"
                       @mouseover="lottiePlay(`setStarter${set.id}_${index}`)">
                    <vx-card>
                      <div class="vx-row">
                        <div class="vx-col w-2/3 flex items-center justify-center">
                          <div class="flex items-center w-full">
                            <div class="p-1 flex items-center justify-center rounded mr-6"  v-if="set.lottie"
                                 style="background: rgb(0 0 0 / 25%) !important">
                              <div class="con-vs-avatar bg-transparent  " style="width: 85px; height: 85px;">
                                <div class="con-img vs-avatar--con-img flex items-center justify-center">
                                  <lottie-animation
                                    :ref="`setStarter${set.id}_${index}`" :autoPlay="false"
                                    :loop="true" :path="set.lottie" :speed="1" :width="120"/>
                                </div>
                              </div>
                            </div>

                            <div class="w-2/3">
                              <h1 class="font-bold">{{ set.name }}</h1>
                              <vs-progress :percent="50" class=""/>
                            </div>

                          </div>
                        </div>
                        <div class="vx-col w-1/3 flex items-center justify-center">
                          <div class="w-full">

                          </div>
                        </div>
                      </div>
                    </vx-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="simple-spinner">
        <span></span>
      </div>


    </div>
  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'
import LottieAnimation from '@/components/lottie/LottieAnimation'

export default {
  data() {
    return {
      courseData: null,
      selectorData: null,

      totalSteps: 5,
      currentStep: 0,

      errorOccurred: false

    }
  },
  computed: {
    setColorProgress() {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgba(0,0,0,0.2)'
      if (theme === 'midnight') return 'rgba(0,0,0,0.5)'
      if (theme === 'dark') return 'rgba(0,0,0,0.2)'
    },
    activeCourseInfo() {
      return this.$store.state.AppActiveCourse
    }
  },
  components: {
    RadialProgressBar,
    LottieAnimation
  },
  methods: {
    fetchCourseDetails(id) {
      this.$http.get(`courses/${id}`)
        .then(response => {

          if (response.status === 200) {
            this.courseData = response.data.data
            this.fetchSelectorData(id)
          }

        })
        .catch(() => {
          this.errorOccurred = true
        })
    },
    fetchSelectorData(id) {
      this.$http.get(`app/flashcard/selector?courseId=${id}`)
        .then(response => {
          if (response.status === 200) {
            this.selectorData = response.data.data
          }
        }).catch(() => {
      })
    },
    lottiePlay(ref) {
      this.$refs[ref][0].play()
    },
    lottieStop(ref) {
      this.$refs[ref][0].stop()
    }
  },
  created() {
    this.fetchCourseDetails(this.activeCourseInfo.id)

    setTimeout(() => {
      this.currentStep = 1
    }, 1500)
  },

}
</script>

<style scoped>

</style>
